<template>
  <v-dialog
    v-model="modal"
    max-width="400"
    persistent
    @keydown.esc="close"
  >
    <template #activator="{ on }">
      <v-list-item v-bind="$props" v-on="on" class="cursor-pointer">
        <slot name="default" />
      </v-list-item>
    </template>
    <v-card>
      <v-card-title class="py-2 blue white--text">{{ modalTitle }}</v-card-title>
      <v-form
        lazy-validation
        class="form-container"
        ref="form"
        v-model="form"
        :disabled="submitLoading"
        @submit.prevent="submit"
      >
        <v-card-text class="pb-1">
          <v-text-field
            outlined
            dense
            clearable
            v-model="oldPassword"
            :rules="[rules.required]"
            :error-messages="oldErrors"
            type="password"
            :label="oldPasswordLabel"
            maxlength="255"
            aria-autocomplete="both"
            aria-haspopup="false"
            autocapitalize="off"
            autocomplete="off"
            autocorrect="off"
            spellcheck="false"
          />
          <v-text-field
            outlined
            dense
            clearable
            v-model="newPassword"
            :rules="[rules.required]"
            :error-messages="newErrors"
            type="password"
            :label="newPasswordLabel"
            maxlength="255"
            aria-autocomplete="both"
            aria-haspopup="false"
            autocapitalize="off"
            autocomplete="off"
            autocorrect="off"
            spellcheck="false"
          />
          <v-text-field
            outlined
            dense
            clearable
            v-model="retPassword"
            :rules="[rules.required]"
            :error-messages="retErrors"
            type="password"
            :label="confirmPasswordLabel"
            maxlength="255"
            aria-autocomplete="both"
            aria-haspopup="false"
            autocapitalize="off"
            autocomplete="off"
            autocorrect="off"
            spellcheck="false"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            dark
            elevation="0"
            color="blue"
            :loading="submitLoading"
            type="submit"
          >
            {{ okButton }}
          </v-btn>
          <v-btn
            elevation="0"
            :disabled="!!submitLoading"
            @click.stop="close"
          >
            {{ cancelButton }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import { VForm } from 'vuetify/types/custom';
import Http, { HttpError } from '@/utils/Http';
import intl from '@/utils/intl';
import validators from '@/utils/validators';

export default Vue.extend({
  name: 'ChangePasswordModal',
  mixins: [validators],
  data() {
    return {
      modal: false,
      form: true,
      submitLoading: false,
      oldPassword: null,
      newPassword: null,
      retPassword: null,
      oldErrors: [],
      newErrors: [],
      retErrors: []
    }
  },
  computed: {
    modalTitle(): string {
      return intl.t('views.changePassword.title');
    },
    oldPasswordLabel(): string {
      return intl.t('views.changePassword.oldPassword');
    },
    newPasswordLabel(): string {
      return intl.t('views.changePassword.newPassword');
    },
    confirmPasswordLabel(): string {
      return intl.t('views.changePassword.confirmPassword');
    },
    cancelButton(): string {
      return intl.t('cancel');
    },
    okButton(): string {
      return intl.t('ok');
    }
  },
  methods: {
    close(): void {
      (this.$refs.form as VForm).reset();
      this.modal = false;
    },
    async submit(): Promise<void> {
      if ((this.$refs.form as VForm).validate()) {
        this.submitLoading = true;
        const data = {
          old_password: this.oldPassword,
          new_password: this.newPassword,
          confirm_password: this.retPassword
        };
        try {
          let response = await (new Http()).put('/v1/account/change-password', JSON.stringify(data));
          this.$root.$children[0].$children[0].setFlash('success', response.data.message);
          this.close();
        } catch (error) {
          const err = (error as HttpError).response?.data.error;
          if ('old_password' in err) {
            this.oldErrors = err.old_password;
          }
          if ('new_password' in err) {
            this.newErrors = err.new_password;
          }
          if ('confirm_password' in err) {
            this.retErrors = err.confirm_password;
          }
          this.$root.$children[0].$children[0].setFlash('error', err.message);
        }
        this.submitLoading = false;
      }
    }
  }
});
</script>
